import React, { useContext, useEffect, useState } from "react";
import { LAView } from "../../components";
import { ThemeContext } from "../../context/ThemeProvider";
import axios from "axios";
import { GET_PRODUCT_PRICES } from "../../api/access_code";
import { THIRD_PARTY_CONFIG } from "../../../app_constant";

const VolumePurchase = () => {
  
  const [activeTab, setActiveTab] = useState("starter");
  const { theme, currentTheme } = useContext(ThemeContext);
  const [products, setProducts] = useState(null);

  useEffect(() => {
    getPrices();
  }, []);
  const getPrices = async () => {
    try {
      const countryData = await axios.get("https://api.country.is");
      const pricesData = await GET_PRODUCT_PRICES(
        THIRD_PARTY_CONFIG?.PRODUCT_ID
      );
      if (pricesData?.status) {
        const updatedProducts = await Promise.all(
          pricesData?.data?.map(async (ele) => {
            const details = await getProductDetails(ele?.priceId);
            return {
              ...ele,
              currency:
                countryData?.data?.country == "IN" &&
                details?.currency_options?.inr
                  ? "inr"
                  : "usd",
              unit_amount:
                countryData?.data?.country == "IN" &&
                details?.currency_options?.inr
                  ? details?.currency_options?.inr?.unit_amount
                  : details?.currency_options?.usd?.unit_amount,

              details: details,
            };
          })
        );
        

        setProducts(updatedProducts);
 
      }
    } catch (err) {
      
    }
  };

  const getProductDetails = async (priceId) => {

    try {
      const data = await axios.get(
        `https://api.stripe.com/v1/prices/${priceId}?expand[]=currency_options`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_STRIPE_SECRET_KEY}`,
          },
        }
      );
      return data?.data;
    } catch (err) {
      
      return null;
    }
  };

  function threeMonthDiscount() {
    const monthlyPrice = month?.unit_amount ?? "0";
    const threeMonthPrice = threeMonth?.unit_amount ?? "0";

    const percentage =
      ((monthlyPrice * 3 - threeMonthPrice) * 100) / (monthlyPrice * 3);
    return isNaN(percentage) ? null : percentage.toFixed(0) + "%";
  }

  function sixMonthDiscount() {
    const monthlyPrice = month?.unit_amount ?? "0";
    const sixMonthPrice = sixMonth?.unit_amount ?? "0";

    const percentage =
      ((monthlyPrice * 6 - sixMonthPrice) * 100) / (monthlyPrice * 6);
    return isNaN(percentage) ? null : percentage.toFixed(0) + "%";
  }

  function yearlyDiscount() {
    const monthlyPrice = month?.unit_amount ?? "0";
    const annualPrice = annual?.unit_amount ?? "0";
    const percentage =
      ((monthlyPrice * 12 - annualPrice) * 100) / (monthlyPrice * 12);

    return isNaN(percentage) ? null : percentage.toFixed(0) + "%";
  }

  const month = products?.planData?.find(
    (e) => e?.interval == "month" && e?.interval_count == 1
  );
  const threeMonth = products?.planData?.find(
    (e) => e?.interval == "month" && e?.interval_count == 3
  );
  const sixMonth = products?.planData?.find(
    (e) => e?.interval == "month" && e?.interval_count == 6
  );
  const annual = products?.planData?.find(
    (e) => e?.interval == "year" && e?.interval_count == 1
  );
  const oneDay = products?.planData?.find(
    (e) => e?.interval == "day" && e?.interval_count == 1
  );
  const threeMonthPercentage = threeMonthDiscount();
  const sixMonthPercentage = sixMonthDiscount();
  const yearlyPercentage = yearlyDiscount();
  const planDescriptions = {
    Monthly: "",
    Quarterly: "Most Popular",
    Semiannual: "",
    Annual: "Best Value",
  };
  const discounts = {
    Quarterly: threeMonthPercentage,
    Semiannual: sixMonthPercentage,
    Annual: yearlyPercentage,
  };

  const billingDescriptions = {
    Monthly: "Billed every month",
    Quarterly: "Billed every 3 months",
    Semiannual: "Billed every 6 months",
    Annual: "Billed every year",
  };

  function getMonthPrice(price, monthName) {
    var number = Number(price);
    switch (monthName) {
      case "Monthly":
        return number.toFixed(2);
      case "Quarterly":
        return (number / 3).toFixed(2);
      case "Annual":
        return (number / 12).toFixed(2);
      case "Semiannual":
        return (number / 6).toFixed(2);
      default:
        return number.toFixed(2);
    }
  }

  return (
    <div className="main-content w-full pt-8 pb-20">
      <div className="p-3 sm:p-3 md:p-4 lg:p-4  w-full mb-4">
        <h2 className="text-center my-2"> volume purchase </h2>

        <div className="flex items-center justify-center gap-4">
          <button
            onClick={() => setActiveTab("starter")}
            className={` ${
              activeTab === "starter"
                ? "bg-slate-800 text-white"
                : "border-slate-800 text-slate-800"
            } px-4 py-2 border `}
          >
            Starter Plan
          </button>
          <button
            onClick={() => setActiveTab("growth")}
            className={` ${
              activeTab === "growth"
                ? "bg-slate-800 text-white"
                : "border-slate-800 text-slate-800"
            } px-4 py-2 border `}
          >
            Growth Plan
          </button>
          <button
            onClick={() => setActiveTab("enterprise")}
            className={` ${
              activeTab === "enterprise"
                ? "bg-slate-800 text-white"
                : "border-slate-800 text-slate-800"
            } px-4 py-2 border `}
          >
            Enterprise Plan
          </button>
        </div>

        {activeTab === "starter" && (
          <div className="flex items-center justify-center gap-4 mt-2">
            <p> * Suitable for small teams</p>
            <p> * 10% discount</p>
            <p> * 2 to 10 licenses</p>
          </div>
        )}
        {activeTab === "growth" && (
          <div className="flex items-center justify-center gap-4 mt-2">
            <p> * Designed for growing organizations</p>
            <p> * 15% discount</p>
            <p> * 11 to 50 licenses</p>
          </div>
        )}
        {activeTab === "enterprise" && (
          <div className="flex items-center justify-center gap-4 mt-2">
            <p> * Tailored for large institutions</p>
            <p> * 20% discount</p>
            <p> * 50 and more licenses</p>
          </div>
        )}

        <div>
          <div className="py-4 px-2 mx-auto max-w-screen-xl lg:py-8 lg:px-2">
            <div className="space-y-2 lg:grid lg:grid-cols-4 md:grid-cols-2 sm:gap-6 xl:gap-10 lg:space-y-0">
              {products
                ?.filter(
                  (type) =>
                    type?.interval === "month" || type?.interval === "year"
                )
                
                ?.filter((active) => active?.active === true)
                ?.map((ele, index) => {
                  return (
                    <div
                      key={ele?.priceId}
                      className={`flex w-full flex-col p-6 mx-auto max-w-lg text-center text-gray-900 rounded-3xl border-2 shadow dark:text-white xl:p-8 bg-white dark:bg-gray-800 ${
                        ele.description === "Quarterly" ||
                        ele.description === "Annual"
                          ? "border-gray-600 dark:border-gray-300"
                          : "border-gray-200 dark:border-gray-800"
                      }`}
                    >
                      <LAView
                        styles={{
                          color: `${
                            currentTheme === "light"
                              ? theme.THEME_DARK
                              : theme?.NORMAL_COLOR_WHITE
                          }`,
                        }}
                      >
                        <span className="text-base font-extrabold">
                          &nbsp;{planDescriptions[ele?.description]}
                        </span>
                      </LAView>

                      <h3 className=" text-3xl">{ele?.description}</h3>

                      <div className=" justify-center items-baseline mt-6">
                        <span className="mr-1 text-2xl font-bold">
                          {ele?.currency === "inr" ? "₹" : "$"}
                        </span>
                        <span className="mr-1 text-3xl font-extrabold">
                          {(ele?.unit_amount / 100).toFixed(2)}
                        </span>
                        <p className="text-gray-500 dark:text-gray-400">
                          {billingDescriptions[ele?.description] ||
                            ele?.description}
                        </p>

                        {ele?.description !== "Monthly" && (
                          <p className="mt-4 text-sm text-gray-500 dark:text-gray-400 mb-auto">
                            That's only &nbsp;
                            <span className="font-bold text-gray-800 dark:text-gray-200 mb-10">
                              {ele?.currency === "inr" ? "₹" : "$"}
                              {(
                                getMonthPrice(
                                  ele?.unit_amount,
                                  ele?.description
                                ) / 100
                              ).toFixed(2)}
                              &nbsp;per month!
                              {discounts[ele?.description] && (
                                <LAView
                                  className="py-1 px-6 rounded-full text-xs font-extrabold uppercase tracking-wide my-2 inline-block bg"
                                  styles={{
                                    background: `${
                                      currentTheme === "light"
                                        ? theme.THEME_PREMIUM_BACKGROUND
                                        : theme?.THEME_LIGHT
                                    }`,
                                    color: `${theme.THEME_DARK}`,
                                  }}
                                >
                                  <span className="px-2">
                                    {" "}
                                    {discounts[ele?.description]} OFF
                                  </span>
                                </LAView>
                              )}
                            </span>
                            <br /> &nbsp;
                            <br /> &nbsp;
                          </p>
                        )}
                      </div>
                      <div>
                        <form className="max-w-xs mx-auto">
                          <label
                            for="quantity-input"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                          >
                            Choose quantity:
                          </label>
                          <div className="relative flex items-center max-w-[8rem]">
                            <button
                              type="button"
                              id="decrement-button"
                              data-input-counter-decrement="quantity-input"
                              className="bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:border-gray-600 hover:bg-gray-200 border border-gray-300 rounded-s-lg p-3 h-11 focus:ring-gray-100 dark:focus:ring-gray-700 focus:ring-2 focus:outline-none"
                            >
                              <svg
                                className="w-3 h-3 text-gray-900 dark:text-white"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 18 2"
                              >
                                <path
                                  stroke="currentColor"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M1 1h16"
                                />
                              </svg>
                            </button>
                            <input
                              type="text"
                              id="quantity-input"
                              data-input-counter
                              aria-describedby="helper-text-explanation"
                              className="bg-gray-50 border-x-0 border-gray-300 h-11 text-center text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block w-full py-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              placeholder="999"
                              required
                            />
                            <button
                              type="button"
                              id="increment-button"
                              data-input-counter-increment="quantity-input"
                              className="bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:border-gray-600 hover:bg-gray-200 border border-gray-300 rounded-e-lg p-3 h-11 focus:ring-gray-100 dark:focus:ring-gray-700 focus:ring-2 focus:outline-none"
                            >
                              <svg
                                className="w-3 h-3 text-gray-900 dark:text-white"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 18 18"
                              >
                                <path
                                  stroke="currentColor"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M9 1v16M1 9h16"
                                />
                              </svg>
                            </button>
                          </div>
                        </form>
                      </div>
                      <LAView
                        className="mt-auto text-white hover:bg-gray-400 font-bold rounded-lg text-base py-4 text-center"
                        styles={{
                          background: `${
                            currentTheme === "light"
                              ? ele.description === "Quarterly" ||
                                ele.description === "Annual"
                                ? theme.THEME_DARK
                                : theme.THEME_LIGHT
                              : ele.description === "Quarterly" ||
                                ele.description === "Annual"
                              ? theme?.NORMAL_COLOR_WHITE
                              : theme?.THEME_TEXT_GRAY
                          }`,
                          color: `${
                            currentTheme === "light" ? "white" : "black"
                          }`,
                        }}
                      >
                        <button
                          className="w-full">
                          Purchase
                        </button>
                      </LAView>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VolumePurchase;
